export default __webpack_public_path__ + "static/media/screen12.ce62378e.svg";